export enum EShop {
  STEAM = 'STEAM',
}

export const stringToEShop = (str: string) =>
  EShop[str.toUpperCase() as keyof typeof EShop]
